import React from 'react';
import Icon from '../../../components/AppIcon';

const ServiceBreakdown = () => {
  const services = [
    {
      icon: 'FileText',
      title: 'Contract Disputes',
      description: 'Comprehensive representation in contract breaches, commercial disagreements, and business relationship disputes with strategic resolution approaches.'
    },
    {
      icon: 'Home',
      title: 'Property Litigation',
      description: 'Expert handling of property disputes, land conflicts, boundary issues, and real estate litigation with thorough legal representation.'
    },
    {
      icon: 'DollarSign',
      title: 'Debt Recovery',
      description: 'Efficient debt collection services and judgment enforcement to recover outstanding debts and protect your financial interests.'
    },
    {
      icon: 'Building2',
      title: 'Commercial Disputes',
      description: 'Strategic litigation support for business disputes, partnership conflicts, and commercial litigation matters requiring expert advocacy.'
    },
    {
      icon: 'TrendingUp',
      title: 'Appellate Proceedings',
      description: 'Skilled appellate advocacy for appeals and reviews, ensuring comprehensive legal representation at all court levels.'
    },
    {
      icon: 'Users',
      title: 'Alternative Dispute Resolution',
      description: 'Mediation and arbitration services to resolve disputes efficiently outside traditional court proceedings when appropriate.'
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-surface/10 to-primary/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-heading font-bold text-text-primary mb-4">
            Civil Litigation Services
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            Comprehensive litigation services covering all aspects of civil dispute resolution with strategic advocacy and courtroom excellence.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-md border border-border-light hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-14 h-14 bg-gradient-to-br from-primary to-accent rounded-xl flex items-center justify-center">
                  <Icon name={service.icon} size={24} color="white" strokeWidth={2} />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-heading font-semibold text-text-primary mb-3">
                    {service.title}
                  </h3>
                  <p className="text-text-secondary leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceBreakdown;